import {
  API_BASE_URL,
  ASSETS_URL,
  STATIC_ASSETS_URL,
  isFilesCookieEnabled,
} from "./consts"
import { isBabeleHost } from "./cookies"
import { useAppStore } from "@src/state"

const isAssetPath = (path: string) => /^[\\/]?assets[\\/]/.test(path)

const isBundledStaticPath = (path: string) => /^[\\/]?static[\\/]/.test(path)

const isPrivateAssetPath = (path: string) =>
  /^[\\/]?assets[\\/]private[\\/]/.test(path)

// Host that serves a stored file path. assets/ paths are served by the API
// (the assets hosts only serve legacy Images paths). Off babele hosts (a
// custom domain), the filesToken cookie stays on the current host, so private
// files go through the app's own /assets/private proxy. Files bundled with the
// web client exist only on the static assets host.
export const assetsHostFor = (path: string): string => {
  if (isBundledStaticPath(path)) return STATIC_ASSETS_URL
  if (!isAssetPath(path)) return ASSETS_URL
  if (isFilesCookieEnabled() && !isBabeleHost() && isPrivateAssetPath(path))
    return window.location.origin
  return API_BASE_URL
}

// The editor's attach button saves absolute links, so a local build saved local ones.
export const isLocalHost = (host: string) =>
  /^(localhost|127\.0\.0\.1|\[::1\])(:\d+)?$/i.test(host)

// Absolute URLs saved earlier point at the old app, the custom domain, the
// assets host, the API or a local build. Re-point them at the host that serves their path now.
export const rehostSavedUrl = (url: string): string | undefined => {
  const { customDnsHost } = useAppStore.getState()
  const hosts = ["https://app.babele.co", ASSETS_URL, STATIC_ASSETS_URL]
  if (customDnsHost) hosts.push(`https://${customDnsHost}`)
  const local = url.match(/^http:\/\/([^/?#]+)/i)
  if (local && isLocalHost(local[1])) hosts.push(local[0])

  const host = hosts.find((h) => url.startsWith(h))
  if (!host) return undefined

  const path = url.slice(host.length)
  // Anything else on these hosts is an app page, such as a survey link.
  if (!/^\/(assets|images|static)\//i.test(path)) return undefined
  return `${assetsHostFor(path)}${path}`
}
